import { httpRequest } from "@services/http";

/** One selectable Use Case for a campaign's vertical (MPN-1689). */
export interface UseCaseOption {
    code: string;
    name: string;
    /** What this choice implies on the holdout report, so the consequence is visible here. */
    funnel_stage: string;
}

const BASE = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches`;

export async function getUseCaseOptions(launchId: number): Promise<UseCaseOption[]> {
    return httpRequest<UseCaseOption[]>(`${BASE}/${launchId}/use-case-options/`, {
        method: "GET",
    });
}

/** What the campaign is currently set to. Its own route -- the launch schema does not carry
    the field, and a dropdown that cannot show the stored value reads as "nobody set this". */
export async function getUseCase(launchId: number): Promise<{ use_case: string }> {
    return httpRequest<{ use_case: string }>(`${BASE}/${launchId}/use-case/`, {
        method: "GET",
    });
}

export async function setUseCase(launchId: number, useCase: string) {
    return httpRequest(`${BASE}/${launchId}/use-case/`, {
        method: "PATCH",
        body: { use_case: useCase },
    });
}
